<template>
  <div class="consultDetail">
    <div class="informationBox">
      <div class="information">
        <div class="information-top">
          <img
            v-if="data.avatar && data.switchChecked == 1"
            :src="miXinGetImgUrl(data.avatar)"
            alt
            style="width: 30px; height: 30px; border-radius: 50%"
          />
          <img
            v-else
            src="../../assets/portrait.png"
            alt
            style="width: 30px; height: 30px; border-radius: 50%"
          />
          <span class="name" v-if="data.switchChecked == 0">匿名用户</span>
          <span class="name" v-else>{{ data.nickName }}</span>
        </div>
        <div class="information-center">
          <span class="message">{{ data.message }}</span>
        </div>
        <div class="information-bottom" v-if="data.imgUrl">
          <div class="photo" v-for="(item, index) in images" :key="index">
            <img :src="item" @click="getImg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="contentBox">
      <div class="content">
        <div class="container" v-for="item in replyList" :key="item.id">
          <div class="container-top">
            <img
              v-if="item.avatar && item.switchChecked == 1"
              :src="miXinGetImgUrl(item.avatar)"
              alt
              style="width: 30px; height: 30px; border-radius: 50%"
            />
            <img
              v-else
              src="../../assets/portrait.png"
              alt
              style="width: 30px; height: 30px; border-radius: 50%"
            />
            <span class="name" v-if="item.switchChecked == 0">匿名用户</span>
            <span class="name" v-else>{{ item.nickName }}</span>
            <span class="time">{{ item.createTime }}</span>
          </div>
          <div class="container-center">
            <span class="message">{{ item.message }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 30px"></div>
  </div>
</template>

<script>
import { leavingInfo } from "../../api/user";
import { ImagePreview, Toast } from "vant";
export default {
  name: "consultDetail",
  data() {
    return {
      images: [],
      id: "",
      data: {},
      replyList: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getData();
  },
  methods: {
    getImg() {
      ImagePreview({
        images: this.images,
      });
    },
    getData() {
      let index=localStorage.getItem("userId")
      leavingInfo({ id: this.id,userId:index }).then((res) => {
        if (res.code === 200) {
          this.data = res.data.title;
          if (this.data.imgUrl) {
            this.images.push(this.data.imgUrl);
          }
          this.replyList = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.consultDetail {
  background: rgb(255, 255, 255);
  .mind_top {
    background: #577eff;
    z-index: 99;
    text-align: center;
    font-size: 15px;
    color: white;
  }
  .informationBox {
    display: flex;
    justify-content: center;
    .information {
      display: flex;
      flex-direction: column;
      background: #fff;
      width: 100%;
      border-bottom: 1px solid rgb(224, 224, 224);
      .information-top {
        display: flex;
        align-items: center;
        margin: 20px 20px 5px;
        .name {
          margin: 0 15px;
          font-size: 16px;
          font-weight: 600;
          color: rgb(103, 103, 103);
        }
      }
      .information-center {
        display: flex;
        margin: 10px 20px 20px;
        .message {
          font-size: 15px;
          font-weight: 600;
          color: rgb(49, 49, 49);
        }
      }
      .information-bottom {
        display: flex;
        margin: 0px 15px 15px;
        img {
          min-width: 100%;
          min-height: 180px;
          object-fit: cover;
        }
      }
    }
  }
  .contentBox {
    display: flex;
    justify-content: center;
    .content {
      display: flex;
      width: 100%;
      flex-direction: column;
      background: #fff;
      .container {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid rgb(224, 224, 224);
        .container-top {
          display: flex;
          margin: 20px 20px 5px;
          align-items: center;
          .name {
            margin: 0 15px;
            font-size: 16px;
            font-weight: 600;
            color: rgb(103, 103, 103);
          }
          .time {
            font-size: 16px;
            color: rgb(164, 164, 164);
          }
        }
        .container-center {
          display: flex;
          flex-direction: column;
          margin: 10px 20px 25px 20px;
          .message {
            font-size: 14px;
            color: rgb(52, 52, 52);
            line-height: 22px;
          }
        }
      }
    }
  }
}
</style>